import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchUserFriendMockData } from "../Utils/UserProfileFetchFriendData.js"
import POProfileImageUploader from "../Utils/ProfileImageUploader.js";
import "../Styles/common-styles.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FriendsProfile = ({ userId, setShowPopup, setUserId }) => {
  const [friends, setFriends] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [location, setLocation] = useState(null);
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");

  useEffect(() => {
    const loadProfileData = async () => {
      const profileData = await fetchUserFriendMockData(userId);
      if (profileData) {
        setProfileImage(profileData.imageUrl);
        setLocation(profileData.location);
        setFriends(profileData?.friends || []);
  
        // ✅ Build full name safely
        const name = `${profileData.name?.first || ""} ${profileData.name?.middle || ""} ${profileData.name?.last || ""}`.trim();
        setFullName(name);
      }
    };
  
    if (userId) {
      loadProfileData();
    }
  }, [userId]);

return (
  <div className="up-profile-container">
    <div
      className="overlay-grid-layout"
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Profile Image */}
      <div
        className="up-blog-grid-upper"
        style={{ width: "100%", height: "20%", display: "flex", flexDirection: "row" }}
      >
        <POProfileImageUploader
          fullName={fullName}
          profileImage={profileImage}
          location={location}
        />
      </div>

      {/* Friends Tokens */}
      <div
        className="up-blog-grid-lower"
        style={{
          width: "100%",
          minHeight: "80%",
          marginTop: 30,
          display: "flex",
          flexWrap: "wrap",
          gap: "15px"
        }}
      >
        {!Array.isArray(friends) || friends.length === 0 ? (
          <p className="text-black">No Friends found</p>
        ) : (
          friends.map((friend) => {
            return (
              <div
                key={friend.userId}
                className="friend-token"
                onClick={() => { 
                  setShowPopup(false); // ✅ Close the modal
                  navigate(`/user-account/${friend.userId}`);
                }}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                border: "1px solid #ccc",
                borderRadius: "25px",
                padding: "10px 15px",
                backgroundColor: "rgb(34, 31, 31)",
                boxShadow: "0px 2px 5px rgba(0,0,0,0.1)"
              }}
            >
              <img
                src={friend.imageUrl}
                alt={friend.userName}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px"
                }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                  {friend.userName}
                </span>
                <span style={{ fontSize: "12px", color: "#bbb" }}>
                  {friend.location || "Location Unknown"}
                </span>
              </div>
            </div>
            );
          })
        )}
      </div>
    </div>
  </div>
);
};

export default FriendsProfile;